import React from "react"
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3"

const captchaId = process.env.GOOGLE_RECAPTCHA_KEY

const FormWrapper = ({ children }) => (
  <GoogleReCaptchaProvider reCaptchaKey={captchaId} container={{ element: 'captchaElement' }}>
    <div className="contact-form">
      { children }
      <div className="captcha">
        <div id="captchaElement"></div>
      </div>
    </div>
  </GoogleReCaptchaProvider>
)

export default FormWrapper